import type { HttpGet } from '@/shared/infra/http'
import type { LicenseCatalog, LoadLicenseCatalog } from '@/shared/domain'

export class EdgeLoadLicenseCatalogRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadLicenseCatalog = async () => {
    return this.httpClient.get<LicenseCatalog>({ url: '/licenses/catalog' })
  }
}
